function normalizeBaseUrl(url: string | undefined): string {
  return (url ?? '').replace(/\/$/, '');
}

/** True when the user is on Anadolu Gatsby routes or the Anadolu portal vhost. */
export function isAnadoluPortalContext(pathname?: string): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const path = (pathname ?? window.location.pathname).split('?')[0].split('#')[0];

  if (
    path.startsWith('/anadolu/') ||
    path === '/anadolu' ||
    path.startsWith('/ev/anadolu/') ||
    path === '/ev/anadolu' ||
    path.startsWith('/dashboards/anadolu/') ||
    path === '/dashboards/anadolu'
  ) {
    return true;
  }

  if (window.location.hostname.includes('portal.anadolu')) {
    return true;
  }

  const anadoluPortalUrl = process.env.GATSBY_ANADOLU_PORTAL_URL;
  if (anadoluPortalUrl) {
    try {
      return (
        window.location.hostname === new URL(anadoluPortalUrl).hostname
      );
    } catch {
      return false;
    }
  }

  return false;
}

/** CakePHP portal base URL for login/logout on the current origin. */
export function getPortalBaseUrl(): string {
  const evolvePortal = normalizeBaseUrl(process.env.GATSBY_PORTAL_URL);
  const anadoluPortal = normalizeBaseUrl(process.env.GATSBY_ANADOLU_PORTAL_URL);

  if (isAnadoluPortalContext()) {
    if (anadoluPortal) {
      return anadoluPortal;
    }

    if (typeof window !== 'undefined') {
      return `${window.location.protocol}//${window.location.host}`;
    }
  }

  return evolvePortal;
}

export function buildPortalLoginUrl(
  returnUrl: string,
  error = 'auth.required',
): string {
  return `${getPortalBaseUrl()}/users/login?return_url=${encodeURIComponent(returnUrl)}&error=${error}`;
}

export function buildPortalLogoutUrl(): string {
  return `${getPortalBaseUrl()}/users/logout`;
}

const ANADOLU_BRAND_LOGO = '/images/logo_anadolu_2021.gif';

/** Gatsby static logo path (`/ev` or `/dashboards` pathPrefix). */
export function getAnadoluBrandLogoSrc(pathname?: string): string {
  const path = (pathname ?? (typeof window !== 'undefined' ? window.location.pathname : ''))
    .split('?')[0]
    .split('#')[0];

  if (path.startsWith('/dashboards/') || path === '/dashboards') {
    return `/dashboards${ANADOLU_BRAND_LOGO}`;
  }

  return `/ev${ANADOLU_BRAND_LOGO}`;
}
